import paths from "../router/paths";
import {http} from '@/services/apiResource';
import router from '../router';

export default {

    install(Vue, options) {

        const {store} = options;

        Vue.prototype.hasAccess = (url) => {

            const rota = paths.findIndex(obj => {
                return obj.path === url;
            });

            if (rota < 0) return false;

            if (paths[rota].permissions === null) return true;

            return store.state.permissions.findIndex(permission => paths[rota].permissions.includes(permission)) >= 0;
        };


        http.interceptors.response.use((response) => {
            return response
        }, function (error) {

            if (error.response.status === 403) {
                store.dispatch("logout");
                router.push("/");
            }

            if (error.response.status === 401 && error.response.data.msg === "Usuário sem permissão para acesso!") {
                router.push("/dashboard");
            }

            return Promise.reject(error)
        })

    }
}
